import { useEffect, useState } from "react";
const useDeviceType = ()=>{
    const [deviceType, setDeviceType] = useState("desktop");
    const isIOS = ()=>{
        if (/iPad|iPhone|iPod/.test(navigator.platform)) {
            return true;
        } else {
            return !!(navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform));
        }
    };
    const isIpadOS = ()=>{
        return !!(navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform));
    };
    useEffect(()=>{
        const userAgent = typeof window.navigator === "undefined" ? "" : navigator.userAgent;
        const isMobile = /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) || isIOS() && !isIpadOS();
        const isTablet = /Tablet|PlayBook/i.test(userAgent) || /Macintosh/i.test(userAgent) && "ontouchend" in document || isIpadOS();
        if (isTablet) {
            setDeviceType("tablet");
        } else if (isMobile) {
            setDeviceType("mobile");
        } else {
            setDeviceType("desktop");
        }
    }, []);
    return deviceType;
};
export default useDeviceType;
